export interface ToolboxLabels {
  trigger: string
  close: string
}

export const DEFAULT_TOOLBOX_LABELS: ToolboxLabels = {
  trigger: 'More actions',
  close: 'Close',
}
